module.exports = __webpack_public_path__ + "static/media/right-girl.8730de4e.png";